/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Close } from '@material-ui/icons';
import { seMembershipView, seMembershipSkip } from '../../Shared/WebAnalytics';
import './SoothePassToaster.css';

class SoothePassToaster extends React.Component {
  constructor(props) {
    super(props);
    this.onMaybeLater = this.onMaybeLater.bind(this);
    this.onLearnMore = this.onLearnMore.bind(this);
    this.onClose = this.onClose.bind(this);
    this.getToasterContent = this.getToasterContent.bind(this);
  }

  onMaybeLater() {
    // Track skipping the membership
    const subscription_tier_id = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_tier_id', null);
    const subscription_tier_name = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_tier_name', null);
    seMembershipSkip(subscription_tier_name, subscription_tier_id);
    
    // Close toaster and proceed to next step
    this.props.onClose();
    this.props.onMaybeLater();
  }

  onLearnMore() {
    // Track membership view event
    const subscription_tier_id = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_tier_id', null);
    const subscription_tier_name = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_tier_name', null);
    seMembershipView(subscription_tier_name, subscription_tier_id);
    
    // Close toaster and show learn more modal
    this.props.onClose();
    this.props.onLearnMore();
  }

  onClose() {
    this.props.onClose();
    this.props.onMaybeLater(); // Default to proceeding when closing
  }

  getToasterContent() {
    const discountInfo = get(this.props, 'client.soothe_pass.discount', {});
    const hasDiscount = get(discountInfo, 'has_discount', false);
    const serviceText = get(discountInfo, 'service_text', '');
    const marketingText = get(discountInfo, 'marketing_text', '');
    
    // Get pricing information from cart billing
    const billing = get(this.props, 'booking.cart.billing', {});
    const topBillingItems = get(billing, 'top_billing_line_items', []);
    
    // Find service price (first non-subscription item)
    const serviceItem = topBillingItems.find(item => 
      !item.title.toLowerCase().includes('soothepass') && 
      !item.title.toLowerCase().includes('subscription')
    );
    
    const originalPrice = get(serviceItem, 'strike_through_text', '');
    const discountedPrice = get(serviceItem, 'amount', '');

    if (hasDiscount) {
      return {
        title: 'Limited time offer!',
        subtitle: serviceText || 'Get an additional 30% off your first month! Discount applied at checkout.'
      };
    } else {
      // Non-discount version with dynamic pricing using server-provided content
      const soothePassInfo = get(this.props, 'booking.cart.info_fields.soothe_pass', {});
      const header = get(soothePassInfo, 'header', '');
      const tagline = get(soothePassInfo, 'tagline', '');
      
      // Use server-provided header or fallback to dynamic pricing
      const title = header || (originalPrice && discountedPrice 
        ? `Your massage is ${originalPrice}. Get it for ${discountedPrice}.`
        : 'Save with SoothePass™');
      
      // Use server-provided tagline or fallback
      const subtitle = tagline || 'Try SoothePass™ and book at a discounted rate every time. Terms apply.';
      
      return {
        title: title.replace(/\\n/g, '\n'), // Handle escaped newline characters from server
        subtitle
      };
    }
  }

  render() {
    const { isVisible } = this.props;
    const content = this.getToasterContent();

    if (!isVisible) {
      return null;
    }

    return (
      <div className="soothe-pass-toaster-overlay">
        <div className="soothe-pass-toaster">
          <div className="toaster-header">
            <button
              type="button"
              className="toaster-close-btn"
              onClick={this.onClose}
              aria-label="Close"
            >
              <Close />
            </button>
          </div>
          
          <div className="toaster-content">
            <div className="toaster-text">
              <h3 className="toaster-title">{content.title}</h3>
              <p className="toaster-subtitle">{content.subtitle}</p>
            </div>
          </div>

          <div className="toaster-actions">
            <button
              type="button"
              className="toaster-btn toaster-btn-primary"
              onClick={this.onMaybeLater}
            >
              Maybe later
            </button>
            <button
              type="button"
              className="toaster-btn toaster-btn-secondary"
              onClick={this.onLearnMore}
            >
              Learn more
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  booking: state.booking,
  client: state.client,
});

export default connect(mapStateToProps)(SoothePassToaster);
